import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { InputPercent } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { REFINANCE } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/refinance-calculator-selectors';
import {
  RefinanceInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const MortgageInterestRateInput: React.FC<RefinanceInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const decimalValue = inputs?.currentMortgageInterestRate;
  const percentageValue = !_.isNil(decimalValue)
    ? num.formatPercent(decimalValue)
    : '';
  const errorMessage = validations?.currentMortgageInterestRate?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'currentMortgageInterestRate',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_n',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'currentMortgageInterestRate',
      calculator: REFINANCE,
      inputType: 'percentage',
    });
  };

  return (
    <InputPercent
      onChange={onInputChange}
      value={percentageValue}
      decimalScale={3}
      numberOfDigits={3}
      error={error}
      errorMessage={errorMessage}
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(MortgageInterestRateInput);
